// extracted by mini-css-extract-plugin
module.exports = {"PostDetailRight__searchPanel":"qs_a bht_rq bht_kr bht_ks","PostDetailRight__brandDaysPosts":"qs_b bht_rq bht_kr bht_ks"};